import Dimensions from "react-native-web/dist/exports/Dimensions";
export var vw = function vw(number) {
  return Dimensions.get('window').width * (number / 100);
};
export var vh = function vh(number) {
  return Dimensions.get('window').height * (number / 100);
};
export var vmin = function vmin(number) {
  return Math.min(Dimensions.get('window').width * (number / 100), Dimensions.get('window').height * (number / 100));
};
export var vmax = function vmax(number) {
  return Math.max(Dimensions.get('window').width * (number / 100), Dimensions.get('window').height * (number / 100));
};